import { unitMapping } from '#src/lib/style.ts';

type Props = {
  size?: keyof typeof unitMapping;
  className?: string;
};

export const BaseballShortStop = ({ size = 2, className }: Props) => (
  <svg
    className={className}
    style={{ width: unitMapping[size], height: unitMapping[size] }}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.87422 7.3427L7.13842 7.47407L7.81073 8.28548L7.54799 9.746L6.50476 10.6347H3.45233L2.78003 9.82328L3.88508 8.88823L4.32556 9.42917H6.01019L6.24974 9.22825L6.32702 8.78777L6.22656 8.66413L3.96236 8.53276L3.29005 7.72136L3.54507 6.26856L4.5883 5.37988H7.47844L8.11983 6.16037L7.01478 7.09542L6.59749 6.5854H5.08287L4.84331 6.78631L4.77376 7.21906L4.87422 7.3427ZM9.96843 7.3427L12.2326 7.47407L12.9049 8.28548L12.6422 9.746L11.599 10.6347H8.54654L7.87424 9.82328L8.97929 8.88823L9.41977 9.42917H11.1044L11.344 9.22825L11.4212 8.78777L11.3208 8.66413L9.05657 8.53276L8.38426 7.72136L8.63928 6.26856L9.68251 5.37988H12.5726L13.214 6.16037L12.109 7.09542L11.6917 6.5854H10.1771L9.93752 6.78631L9.86797 7.21906L9.96843 7.3427Z"
      fill="white"
    />
  </svg>
);
